import { createRouter, createWebHashHistory } from "vue-router";

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: "/pages/login",
            name: 'login',
            component: () => import('../views/user/Login'),
            meta: { requiresAuth: false },
        },
        {
            path: "/pages/user/register",
            name: 'reg',
            component: () => import('../views/user/Register'),
            meta: { requiresAuth: false },
        },
        {
            path: "/pages/user/findpassword",
            name: 'findpassword',
            component: () => import('../views/user/FindPassword'),
            meta: { requiresAuth: false },
        },
        {
            path: "/pages/user/setPayPassword",
            name: 'setPayPassword',
            component: () => import('../views/user/SetPayPassword'),
        },
        {
            path: "/",
            name: 'home',
            component: () => import('../views/home'),
            props: { tabIndex: 0 },
        },
        {
            path: "/pages/home/market",
            name: 'home/market',
            component: () => import('../views/home'),
            props: { tabIndex: 1 },
        },
        {
            path: "/pages/home/msgs",
            name: 'home/msgs',
            component: () => import('../views/home'),
            props: { tabIndex: 2 },
        },
        {
            path: "/pages/home/find",
            name: 'home/find',
            component: () => import('../views/home'),
            props: { tabIndex: 3 },
        },
        {
            path: "/pages/home/me",
            name: 'home/me',
            component: () => import('../views/home'),
            props: { tabIndex: 4 },
        },
        {
            path: "/pages/language",
            name: 'language',
            component: () => import('../views/user/Language'),
            meta: { requiresAuth: false },
        },
        {
            path: "/pages/user/kefu",
            name: 'kefu',
            component: () => import('../views/user/Kefu'),
            meta: { requiresAuth: false },
        },
        {
            path: "/pages/user/share",
            name: 'share',
            component: () => import('../views/user/Share'),
        },
        {
            path: "/pages/user/team",
            name: 'team',
            component: () => import('../views/user/Team'),
        },
        {
            path: "/pages/withdraw/updatebank",
            name: 'withdraw/updatebank',
            component: () => import('../views/wallet/UpdateBank'),
        },
        {
            path: "/pages/deposit",
            name: 'deposit',
            component: () => import('../views/wallet/Deposit'),
        },
        {
            path: "/pages/withdraw",
            name: 'withdraw',
            component: () => import('../views/wallet/Withdraw'),
        },
        {
            path: "/pages/signalchannel",
            name: 'signalchannel',
            component: () => import('../views/other/SignalChannel'),
        },
        {
            path: "/pages/accountsettle",
            name: 'accountsettle',
            component: () => import('../views/wallet/AccountSettle'),
        },
        {
            path: "/pages/wallet/payrollrecords",
            name: 'wallet/payrollrecords',
            component: () => import('../views/wallet/PayrollRecords'),
        },
        {
            path: "/pages/wallet/financialrecords",
            name: 'wallet/financialrecords',
            component: () => import('../views/wallet/FinancialRecords'),
        },
        {
            path: "/pages/user/inviterecords",
            name: 'user/inviterecords',
            component: () => import('../views/user/InviteRecords'),
        },
        {
            path: "/pages/trade",
            name: 'trade',
            component: () => import('../views/trade/Trade'),
        },
        {
            path: "/pages/trade/traderecords",
            name: 'trade/traderecords',
            component: () => import('../views/trade/TradeRecords'),
        },
        {
            path: "/pages/trade/orderdetail",
            name: 'trade/orderdetail',
            component: () => import('../views/trade/OrderDetail'),
        },
        {   
            path: "/pages/user/accountsecurity",
            name: 'user/accountsecurity',
            component: () => import('../views/user/AccountSecurity'),
        },
        {
            path: "/pages/message/notifyrecords",
            name: 'message/notifyrecords',
            component: () => import('../views/message/NotifyRecords'),
        },
        {
            path: "/pages/appdownload",
            name: 'appdownload',
            component: () => import('../views/other/AppDownload.vue'),
        },
        {
            path: "/pages/find",
            name: 'find',
            component: () => import('../views/other/Find'),
        },

        
        // {
        //     path: "/pages/home/grab",
        //     name:"home/grab",
        //     component: () => import('../views/home'),
        //     props: { tabIndex: 1 }
        // },
        // {
        //     path: "/pages/home/records",
        //     name:"home/records",
        //     component: () => import('../views/home'),
        //     props: { tabIndex: 2 }
        // },
    ]
});

//路由守卫
router.beforeEach((to, from, next) => {
    // 检查是否需要认证
    if (to.matched.some(record => {
        var requiresAuth  = record.meta.requiresAuth
        if(requiresAuth === undefined){
            return true
        }else{
            return requiresAuth
        }
    })) {
        // 假设我们有一个函数或者属性来检查用户是否已经登录
        if (!isAuthenticated()) {
            // 如果用户没有登录，则重定向到登录页面
            next({ path: '/pages/login' });
        } else {
            // 如果用户已登录，允许继续前往目标页面
            next();
            window.scrollTo(0, 0);
        }
    } else {
        // 不需要认证，直接放行
        next();
        window.scrollTo(0, 0);
    }
});

function isAuthenticated() {
    // 这里可以是实际的逻辑，例如检查 localStorage 或者 Vuex store 中是否有 token
    return !!localStorage.getItem('token');
}

export default router;